import { Box, ComponentVersionsInherit, ComponentVersions_3_0, Typography } from 'opensolar-ui'
import { useTranslate } from 'react-admin'

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Box display="flex" flexDirection="column">
        <Typography variant="body2" color="textSecondary">
          {translate('View and manage your quote requests')}
        </Typography>
      </Box>
    </ComponentVersionsInherit>
  )
}

export default {
  list: { lazy: () => import('../common/quotes/QuotesList') },
  options: {
    list: {
      title: 'Quotes',
      subtitle: <Subtitle />,
      breadCrumb: 'Quotes',
    },
  },
}
